"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const query_1 = require("@reduxjs/toolkit/query");
const lodash_1 = require("lodash");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const components_1 = require("components");
const config_1 = require("config");
const merchant_management_v1_api_1 = require("merchant-management-v1-api");
const merchant_management_v2_api_1 = require("merchant-management-v2-api");
const utils_1 = require("utils");
const FeaturesContext_1 = require("../../../context/FeaturesContext");
const PromotionalPlanList_1 = __importDefault(require("../components/PromotionalPlanList"));
const PromotionalPlanListV2_1 = __importDefault(require("../components/PromotionalPlanListV2"));
const CalculatorForm_1 = __importDefault(require("../forms/CalculatorForm"));
const reducer_1 = require("../reducer");
function Calculator() {
    const [plansArgs, setPlansArgs] = (0, react_1.useState)(null);
    const [plansV2Args, setPlansV2Args] = (0, react_1.useState)(null);
    const [purchaseAmount, setPurchaseAmount] = (0, react_1.useState)(0);
    const currentLocation = (0, react_redux_1.useSelector)(reducer_1.selectors.currentLocation);
    const { globalConfig } = (0, react_1.useContext)(FeaturesContext_1.FeaturesContext);
    const { featureFlags } = globalConfig;
    const calculatorPromoPlansVersion = featureFlags?.calculatorPromoPlansV2
        ? 'V2'
        : 'V1';
    // V1 API query
    const { data: plans, isFetching: isFetchingPlans, error: errorFetchingPlans, } = (0, merchant_management_v1_api_1.useGetMerchantManagementV1LocationsIdPlansQuery)(plansArgs ?? query_1.skipToken);
    const plansFix = plans;
    // V2 API query
    const { data: plansV2, isFetching: isFetchingPlansV2, error: errorFetchingPlansV2, } = (0, merchant_management_v2_api_1.useGetMerchantManagementV2LocationsIdPlansQuery)(plansV2Args ?? query_1.skipToken);
    const handleSubmit = async ({ amount }) => {
        setPurchaseAmount(amount);
        if (calculatorPromoPlansVersion === 'V2') {
            setPlansV2Args({
                id: currentLocation.locationId,
                amount,
            });
        }
        else {
            setPlansArgs({
                id: currentLocation.locationId,
                amount,
                activeOnly: true,
            });
        }
    };
    (0, react_1.useEffect)(() => {
        const error = calculatorPromoPlansVersion === 'V2'
            ? errorFetchingPlansV2
            : errorFetchingPlans;
        if (error) {
            if ('data' in error) {
                const data = error.data;
                (0, utils_1.toastError)(data.message);
            }
            else {
                (0, utils_1.toastError)('Error fetching plans');
            }
        }
    }, [errorFetchingPlans, errorFetchingPlansV2, calculatorPromoPlansVersion]);
    const sortedPlans = (0, react_1.useMemo)(() => {
        if (!plansFix)
            return [];
        const [revolvingPlans, nonRevolvingPlans] = (0, lodash_1.partition)(plansFix.plans, ({ name }) => (0, utils_1.isRevolving)(name));
        return [...nonRevolvingPlans, ...revolvingPlans];
    }, [plansFix]);
    const isFetching = calculatorPromoPlansVersion === 'V2' ? isFetchingPlansV2 : isFetchingPlans;
    return ((0, jsx_runtime_1.jsxs)("div", { className: "calculator m-t-30", children: [(0, jsx_runtime_1.jsx)(components_1.H1, { children: "Payment Calculator" }), (0, jsx_runtime_1.jsx)(components_1.P, { variant: "body-large", bold: true, children: "Use this tool to estimate payments" }), (0, jsx_runtime_1.jsx)(CalculatorForm_1.default, { handleSubmit: handleSubmit, isFetchingPlans: isFetching }), calculatorPromoPlansVersion === 'V1' && !(0, lodash_1.isEmpty)(sortedPlans) && ((0, jsx_runtime_1.jsx)(PromotionalPlanList_1.default, { sortedPlans: sortedPlans, purchaseAmount: purchaseAmount, productTypes: [config_1.PRODUCT_TYPE.AC_PRIME], isSaleTransaction: false, lenderSettings: undefined })), calculatorPromoPlansVersion === 'V2' && plansV2 && ((0, jsx_runtime_1.jsx)(PromotionalPlanListV2_1.default, { plansV2: plansV2, purchaseAmount: purchaseAmount }))] }));
}
exports.default = Calculator;
